import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Compass, Globe2, Gem, Leaf } from 'lucide-react';

const services = [
  {
    icon: Compass,
    path: '/services/technical-advisory',
    name: 'Technical Advisory',
    blurb: 'Geological and engineering diligence — historical dataset review, processing flow charts, field studies, and sample collection.',
    tint: 'from-amber-200/40 to-rose-200/30',
  },
  {
    icon: Globe2,
    path: '/services/sourcing',
    name: 'Sourcing',
    blurb: 'Supply chain management for raw materials destined for global buyers — logistics, freight, and shipping that arrive on time.',
    tint: 'from-orange-200/40 to-amber-200/30',
  },
  {
    icon: Gem,
    path: '/services/products',
    name: 'Products Trading',
    blurb: 'Physical brokerage across base metals, coal, and critical minerals — copper, aluminium, gold, coking coal, and more.',
    tint: 'from-rose-200/40 to-yellow-200/30',
  },
  {
    icon: Leaf,
    path: '/services/renewable-energy',
    name: 'Renewable Energy',
    blurb: 'Solar and hydrogen energy solutions — lithium battery storage and off-grid power systems.',
    tint: 'from-lime-200/40 to-amber-200/30',
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="relative z-10 max-w-6xl mx-auto px-6 py-20">
      <div className="text-center mb-16">
        <div className="text-xs uppercase tracking-[0.25em] text-[#8b5a2b] font-medium mb-4">What we do</div>
        <h2 className="text-4xl md:text-5xl font-semibold tracking-[-0.025em] text-[#2a2420]">
          Four practices.{' '}
          <span className="font-serif-display italic font-medium text-[#8b5a2b]">One mandate.</span>
        </h2>
      </div>
      <div className="grid md:grid-cols-2 gap-5">
        {services.map(s => {
          const Icon = s.icon;
          return (
            <Link
              key={s.name}
              to={s.path}
              className="group relative p-8 rounded-3xl bg-white/60 backdrop-blur-xl border border-white/80 shadow-[0_8px_32px_-12px_rgba(80,50,20,0.12)] hover:shadow-[0_16px_48px_-12px_rgba(80,50,20,0.2)] hover:-translate-y-1 hover:bg-white/80 transition-all duration-500 overflow-hidden"
            >
              <div className={`absolute -top-20 -right-20 w-48 h-48 rounded-full bg-gradient-to-br ${s.tint} blur-2xl opacity-70 group-hover:opacity-100 transition-opacity duration-700`} />
              <div className="relative">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-white/70 backdrop-blur-lg border border-white/90 mb-6 shadow-sm text-[#2a2420]">
                  <Icon className="w-5 h-5" strokeWidth={1.75} />
                </div>
                <h3 className="text-xl font-semibold mb-2 tracking-[-0.015em] text-[#2a2420]">{s.name}</h3>
                <p className="text-[#5a4a3a] text-sm leading-relaxed max-w-sm">{s.blurb}</p>
                <div className="mt-6 flex items-center gap-1.5 text-sm text-[#8b5a2b] font-medium opacity-60 group-hover:opacity-100 transition-opacity">
                  Explore <ArrowUpRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default ServicesSection;
